module.exports = __webpack_public_path__ + "img/logo-hdzy.acdd375f.png";